import { Box, SwipeableDrawer, useTheme, Toolbar } from '@mui/material';
import { READER_MENU_ITEMS, ReaderMenuItemConfig } from './ReaderMenuUtils';
import { useState } from 'react';
import ReaderToolbar from './ReaderToolbar';
import { useBookMenuContext } from '../BookMenuContext';
import DrawerContentArea from '../Utilities/DrawerContentArea';
import DynamicMenuItemComponent from './DynamicMenuItemComponent';
import { useTranslation } from 'react-i18next';

export default function HeaderReaderMenu() {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation();
  const { activeMenuView, selectMenuView } = useBookMenuContext();

  const toggleDrawer = (view: string | null, openNew?: boolean) => {
    const openNewState = openNew ?? activeMenuView !== view;
    if (openNewState) {
      selectMenuView(view);
      setOpen(openNewState);
    }

    if (!openNewState) {
      setOpen(openNewState);

      const leavingScreenDuration = theme.transitions.duration.leavingScreen;

      // Wait for the transition to finish before resetting the active menu view
      setTimeout(() => {
        selectMenuView(null);
      }, leavingScreenDuration ?? 0);
    }
  };

  const drawerContent = READER_MENU_ITEMS.find(
    (menuItem) => menuItem.id === activeMenuView,
  ) as ReaderMenuItemConfig;

  return (
    <>
      <ReaderToolbar
        variant='horizontal'
        activeId={activeMenuView}
        onItemClick={(view) => toggleDrawer(view)}
      />
      <SwipeableDrawer
        anchor='bottom'
        hideBackdrop
        open={open}
        slotProps={{
          paper: {
            sx: {
              marginX: { xs: 0, sm: 2 },
              maxHeight: `calc(100% - ${theme.spacing(7)} - ${theme.spacing(2)})`,
              borderTopLeftRadius: 4,
              borderTopRightRadius: 4,
            },
          },
        }}
        onClose={() => toggleDrawer(null, false)}
        onOpen={() => {
          if (activeMenuView) {
            toggleDrawer(activeMenuView, true);
          }
        }}
      >
        <Box sx={{ paddingBottom: 3, paddingX: 2 }}>
          {drawerContent && (
            <DrawerContentArea
              title={t(drawerContent.labelKey)}
              onClose={() => toggleDrawer(null, false)}
              titleId={drawerContent.titleId}
            >
              <DynamicMenuItemComponent
                component={drawerContent.content}
                onClose={() => toggleDrawer(null, false)}
              />
            </DrawerContentArea>
          )}
        </Box>
        <Toolbar />
      </SwipeableDrawer>
    </>
  );
}
